export default {
  type: 'modal',
  instanceName: 'registrar/zero/user/info',
  modalClassName: 'modal-registar-info',
  modalWidth: '670px',
  modalPadding: '20px',
  fields: {
    text: {
      type: 'html'
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/forms/formsConfigs/forms/userInfoConfig.js